export class FileExport {
  fileName?: string | null;
  fileBase64?: string | null;

  constructor(data: Partial<FileExport> = {}) {
    Object.assign(this, data);
    if (!data) {
      return;
    }
  }

  get serialised() {
    return {
      fileName: this.fileName,
      fileBase64: this.fileBase64,
    };
  }
}
